import {call, put, takeLatest} from "@redux-saga/core/effects";
import {authAPI} from "../api/auth.api";
import {AuthActionTypes} from "../actions/actionTypes";
import {cloneDeep} from "lodash";
function* getUsersPrivileges(){
    try {
        const data = yield call(()=> authAPI.getUsersPrivileges());

        let _roles_array = cloneDeep(data.data.results);

        data.data.results.filter((obj, index) => {
            let find_index =  data.data.results.findIndex(o => obj.name === o.name && o.access.length === obj.access.length && JSON.stringify(orderByKey(obj.access)) === JSON.stringify(orderByKey(o.access)));

            if (index !== find_index) {
                if ('in' in _roles_array[find_index]) {
                    _roles_array[find_index].in = _roles_array[find_index].in.concat([{
                        id: obj.id,
                        subsidiary: obj.subsidiary.id
                    }])

                } else {
                    _roles_array[find_index].in = [{
                        id: _roles_array[find_index].id,
                        subsidiary: _roles_array[find_index].subsidiary ? _roles_array[find_index].subsidiary.id : _roles_array[find_index].subsidiary
                    }].concat([{
                        id: obj.id,
                        subsidiary: obj.subsidiary.id
                    }]);
                }
                delete _roles_array[index];
            } else {
                _roles_array[find_index].in = [{
                    id: _roles_array[find_index].id,
                    subsidiary: _roles_array[find_index].subsidiary ? _roles_array[find_index].subsidiary.id : _roles_array[find_index].subsidiary
                }]
            }
        })

        _roles_array.map(role => {
            role.access.map(a => {
                a.id = a.resource_entity.id;
                a.name = a.resource_entity.name
                delete a.resource_entity
            });
            delete role.id;
            delete role.subsidiary;
        })

        data.data.results = _roles_array.filter(p => p)

        yield put({
            type: AuthActionTypes.GET_USERS_PRIVILEGES_SUCCESS,
            payload: data
        });

    } catch (e) {
        yield (put({
            type: AuthActionTypes.GET_USERS_PRIVILEGES_FAIL,
            error: e.message
        }));
    }
}

export function* getUsersPrivilegesWatcher() {
    yield takeLatest(AuthActionTypes.GET_USERS_PRIVILEGES, getUsersPrivileges);

}

function* orderByKey(dict) {
    let obj = {};
    let keys = Object.keys(dict).sort();

    keys.forEach(k => {
        if(k=="id" || k=="resource_entity"){
            //delete dict[k]
        }else {
            if (dict[k] && typeof (dict[k]) == 'object') {
                obj[k] = this.orderByKey(dict[k]);
            } else obj[k] = dict[k];
        }
    });
    return obj;
}